import styles from "./StatusPill.module.css";

export type DraftState =
  | "pending"
  | "approved"
  | "rejected"
  | "scheduled"
  | "published"
  | "failed"
  | "draft";

interface StatusPillProps {
  state: DraftState;
  size?: "sm" | "md";
  withDot?: boolean;
}

const LABEL: Record<DraftState, string> = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
  scheduled: "scheduled",
  published: "published",
  failed: "failed",
  draft: "draft",
};

/** The six draft-lifecycle states as a pill. Matches library-actions.jsx. */
export function StatusPill({ state, size = "md", withDot = true }: StatusPillProps) {
  return (
    <span className={`${styles.pill} ${styles[`s_${size}`]} ${styles[`state_${state}`]}`}>
      {withDot && <span className={styles.dot} aria-hidden="true" />}
      {LABEL[state]}
    </span>
  );
}
